module.exports = __webpack_public_path__ + "static/media/menu-overlay-profile.50c45c28.jpg";